import React, { Fragment } from 'react';

import styles from './Input.module.css';

const Input = ({ type, value, onChange, isInvalid, errorText, placeholder, cySelector }) => (
  <Fragment>
    <input
      data-cy={cySelector}
      className={`${styles.input} ${isInvalid ? styles.error : ''} form-control`}
      type={type}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
    />
    {
      isInvalid &&
      <div className={styles.validationErrorText}>{errorText}</div>
    }
  </Fragment>
);

Input.defaultProps = {
  type: 'text',
  placeholder: '',
  cySelector: ''
}

export default Input;
